import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

import { API } from "@/lib/api";
const ContentContext = createContext({});

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then((r) => setContent(r.data))
      .catch(() => {});
  }, []);
  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
